import PaymentsEdit from '@/components/oa/payform/PaymentsEdit';//付款申请单
import ReimburseEdit from '@/components/oa/payform/ReimburseEdit';//费用报销单


export default {
  install: function (Vue, options) {
    Vue.component("PaymentsEdit", PaymentsEdit)
    Vue.component("ReimburseEdit", ReimburseEdit)
  }
}



// WEBPACK FOOTER //
// ./src/plugin/workflowcomponents.js